function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { memo } from "react";
var SvgEmailSocial = function SvgEmailSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 7.99999C29.8332 6.53333 28.6332 5.33333 27.1665 5.33333H5.83317C4.3665 5.33333 3.1665 6.53333 3.1665 7.99999V24C3.1665 25.4667 4.3665 26.6667 5.83317 26.6667H27.1665C28.6332 26.6667 29.8332 25.4667 29.8332 24V7.99999ZM27.1665 7.99999L16.4998 14.6667L5.83317 7.99999H27.1665ZM27.1665 24H5.83317V10.6667L16.4998 17.3333L27.1665 10.6667V24Z",
    fill: "url(#paint0_linear_7878_34314)",
    style: {}
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7878_34314",
    x1: 3.1665,
    y1: 7.96208,
    x2: 25.3199,
    y2: 28.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBA5",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFEBA5"
    }, "stopColor", "color(display-p3 1.0000 0.9216 0.6471)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#FFC700",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFC700"
    }, "stopColor", "color(display-p3 1.0000 0.7804 0.0000)"), "stopOpacity", 1)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27B",
    style: _defineProperty(_defineProperty({
      stopColor: "#FFE27B"
    }, "stopColor", "color(display-p3 1.0000 0.8863 0.4824)"), "stopOpacity", 1)
  }))));
};
var Memo = /*#__PURE__*/memo(SvgEmailSocial);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/email-social.9213ea38029ba65ab68630321d7f1765.svg";